<template>
    <main>
        <div class="dialog">
            <div class="dialog-inner">
                <h1>{{ $t('smart_home.title') }}</h1>
                <button class="button_clear" @click="handleAppMethod">{{ $t('smart_home.confirm') }}</button>
            </div>
        </div>
    </main>
</template>

<script lang="ts">
import { config } from '@/config/reolink';
import { DIALOG_ADD, DIALOG_REDUCE } from '@/store/mutation-types';
import nProgress from 'nprogress';
import Vue from 'vue';

export default Vue.extend({
    name: 'SmartHome',
    data() {

        return {};

    },
    methods: {
        handleAppMethod() {

            if ( this.$route.params.info?.startsWith( 'alexa' )) {

                this.redirectToAccountCenter();

            } else {

                this.goReolinkApp();

            }

        },
        redirectToAccountCenter() {

            const url = `${config.accountCenterOauth2Url}${location.search}`;
            location.assign( url );

        },
        goReolinkApp() {

            const a = document.createElement( 'a' );

            a.href = location.href.replace( 'https', 'reolinksmarthome' );
            a.click();

        },
        dialogMounted (): void {

            this.$store.commit( DIALOG_ADD );

        },
        dialogDestroyed (): void {

            this.$store.commit( DIALOG_REDUCE );

        }
    },
    mounted() {

        this.handleAppMethod();
        this.dialogMounted();
        nProgress.done();

    },
    beforeDestroy() {

        this.dialogDestroyed();

    }
});
</script>

<style lang="less" scoped>
main{
    min-height: 100vh;
    .dialog{
        //mask
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0,0,0,0.6);
        z-index: 100;
        display: flex;
        align-items: center;
        justify-content: center;
        &-inner{
            width: 311px;
            height: 124px;
            border-radius: 16px;
            box-sizing: border-box;
            padding: 24px;
            background-color: @bg_01;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            h1{
                font-size: 17px;
                font-weight: 500;
                line-height: 22px;
            }
            button{
                font-size: 17px;
                font-weight: 500;
                color: @b_6;
            }
        }
    }
}
</style>
